<script>
  import { createEventDispatcher } from 'svelte';
  import { classDescription } from './personalNotes.js';
  export let rows = [];
  export let selected = '';
  export let loading = false;
  export let nextCursor = null;
  export let error = '';
  const dispatch = createEventDispatcher();
</script>

<section class="note-history" aria-label="Pamokų istorija">
  <h3>Pamokų istorija</h3>
  {#if error}<p role="alert">{error}</p><button type="button" on:click={() => dispatch('more')}>Bandyti dar kartą</button>{/if}
  {#if rows.length === 0 && !loading && !error}<p>Ankstesnių pamokų ar užrašų nėra.</p>{/if}
  <ul>
    {#each rows as row (row.event_id)}
      <li><button type="button" class:selected={selected === row.event_id} aria-current={selected === row.event_id ? 'true' : undefined}
        on:click={() => dispatch('select', row.event_id)}>
        <strong>{row.class_info.title}</strong>
        <span>{classDescription(row.class_info)}</span>
        <small>{row.has_note ? 'Yra užrašai' : 'Užrašų dar nėra'}{new Date(row.class_info.starts_at) > new Date() ? ' · Būsima pamoka' : ''}</small>
      </button></li>
    {/each}
  </ul>
  {#if nextCursor}<button type="button" disabled={loading} on:click={() => dispatch('more')}>Rodyti daugiau</button>{/if}
  {#if loading}<p>Įkeliama istorija...</p>{/if}
</section>

<style>
  .note-history { border-top: 2px solid #cdcebf; margin-top: 28px; padding-top: 8px; }
  ul { padding: 0; list-style: none; }
  li { margin: 8px 0; }
  button { width: 100%; text-align: left; display: flex; flex-direction: column; gap: 5px; padding: 12px; border: 1px solid #dedbcf; background: #fff; color: #24251f; border-radius: 6px; cursor: pointer; overflow-wrap: anywhere; }
  button.selected { border-color: #50633c; background: #edf0e5; }
  span, small { font-size: 13px; }
</style>
